module.exports = __webpack_public_path__ + "img/icon_map_4.f1372095.png";